import {
  Terminal, LayoutGrid, Bot, ListTodo, Zap, Smartphone, Server, Puzzle,
  GraduationCap, Wrench, FolderGit2, Brain, ShieldCheck, KeyRound,
  Cpu, BarChart3, Activity, DollarSign, Sliders, SquareTerminal, Command,
} from "lucide-react";

export const NAV_ITEMS = [
  { id: "command-center", label: "Command Center", icon: Terminal, path: "/" },
  { id: "workspaces", label: "Workspaces", icon: LayoutGrid, path: "/workspaces" },
  { id: "agents", label: "Agents", icon: Bot, path: "/agents" },
  { id: "commands", label: "Commands", icon: Command, path: "/commands" },
  { id: "tasks", label: "Tasks", icon: ListTodo, path: "/tasks" },
  { id: "automations", label: "Automations", icon: Zap, path: "/automations" },
  { id: "devices", label: "Devices", icon: Smartphone, path: "/devices" },
  { id: "servers", label: "Servers", icon: Server, path: "/servers" },
  { id: "plugins", label: "Plugins", icon: Puzzle, path: "/plugins" },
  { id: "skills", label: "Skills", icon: GraduationCap, path: "/skills" },
  { id: "tools", label: "Tools", icon: Wrench, path: "/tools" },
  { id: "files", label: "Files", icon: FolderGit2, path: "/files" },
  { id: "memory", label: "Memory", icon: Brain, path: "/memory" },
  { id: "security", label: "Security", icon: ShieldCheck, path: "/security" },
  { id: "vault", label: "Vault", icon: KeyRound, path: "/vault" },
  { id: "models", label: "Models", icon: Cpu, path: "/models" },
  { id: "ai-usage", label: "AI Usage", icon: BarChart3, path: "/ai-usage" },
  { id: "activity", label: "Activity", icon: Activity, path: "/activity" },
  { id: "revenue", label: "Revenue", icon: DollarSign, path: "/revenue" },
  { id: "terminal", label: "Terminal", icon: SquareTerminal, path: "/terminal" },
  { id: "settings", label: "Settings", icon: Sliders, path: "/settings" },
];
